import { c as m, a as h, i as A } from "./__packages__deps__validate-customization-2bfb56fe.js";
import { u as g, q as p, g as v } from "./__packages__deps__queryProductByHandle-018098bd.js";
import { m as b, r as w, c as z } from "./__packages__deps__web-929faed1.js";
const f = () => document.querySelectorAll("[data-render-on='cart']"), y = (t) => {
  var s, i, l;
  const o = v((() => {
    var n, a;
    return (a = (n = t == null ? void 0 : t.product) == null ? void 0 : n.metafields.find((r) => (r == null ? void 0 : r.key) === "jp_attributes")) == null ? void 0 : a.value;
  })(), "p_attributes");
  return o.success ? (l = (i = (s = o.data) == null ? void 0 : s.find((n) => n.slug === "available-customizations")) == null ? void 0 : i.value) == null ? void 0 : l.split(",") : void 0;
}, c = (t) => {
  var o;
  const e = (o = t.closest(".customization-cart-element")) == null ? void 0 : o.classList;
  e == null || e.remove("tw-hidden");
}, [u, B] = b([...f()]);
window.customization.refreshCartButtons = () => {
  var t, e;
  B([...f()]), (e = (t = window.customization) == null ? void 0 : t.refreshOpenDrawerButtons) == null || e.call(t);
};
const S = () => (z(() => {
  u() && u().forEach((t) => {
    const e = t.getAttribute("data-handle-product"), o = t.getAttribute("data-with-customizations") === "true";
    if (e)
      return o ? c(t) : fetch(g, {
        method: "POST",
        body: JSON.stringify({
          query: p,
          variables: {
            handle: e
          }
        }),
        headers: {
          "X-Shopify-Storefront-Access-Token": window.storefrontApi.accessToken,
          "Content-Type": "application/json"
        }
      }).then((s) => s.json()).then(({
        data: s
      }) => {
        if (!s)
          return;
        const i = y(s);
        if (!i)
          return;
        if (i.some((n) => {
          const a = m()[n], r = window.customizationProduct.availableCustomizations[n];
          return a ? r && h(a) && A(a) : !1;
        }))
          return c(t);
      }).catch((s) => console.log(s));
  });
}), null), d = document.getElementById("validate-customization-button-cart");
d && w(S, d);
